import { JSX } from 'react';
import { ControllerRenderProps, FieldErrors, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import NumericField from 'shared/components/formFields/numeric-field/numeric-field';

type Props = {
  field: ControllerRenderProps<FieldValues, string>;
  errors: FieldErrors<FieldValues>;
};

const DetectionLoopNumberConstants = {
  min: 1,
  max: 255,
};

const getErrorMessage = (error: any): string | undefined => {
  if (!error) return undefined;
  if (typeof error.message === 'string') return error.message;
  if (typeof error === 'string') return error;
  return undefined;
};

const DesoDetectionLoopNumberTextField = ({ field, errors }: Readonly<Props>): JSX.Element => {
  const { t } = useTranslation('deviceDetails');

  return (
    <NumericField
      field={field}
      fieldName="detectionLoopNumber"
      label={t('info.detectionLoopNumberLabel')}
      min={DetectionLoopNumberConstants.min}
      max={DetectionLoopNumberConstants.max}
      step={1}
      id="detectionLoopNumberInput"
      className="form-field"
      error={!!errors.detectionLoopNumber}
      helperText={getErrorMessage(errors.detectionLoopNumber)}
    />
  );
};

export default DesoDetectionLoopNumberTextField;
